export default __webpack_public_path__ + "static/hammond-9ae9d3f9bb5b11ae59885431eadd50b1.jpg";